import { render, staticRenderFns } from "./MessageInput.vue?vue&type=template&id=04b85701&scoped=true&"
import script from "./MessageInput.vue?vue&type=script&lang=js&"
export * from "./MessageInput.vue?vue&type=script&lang=js&"
import style0 from "./MessageInput.vue?vue&type=style&index=0&id=04b85701&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b85701",
  null
  
)

export default component.exports